/**
 * BetterWild Allergy Relief PDP (ctr-ar) — gallery, buybox, carousels, accordion, modal.
 * Visual source: .ref/ctr-ar/screenshots
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-ctr-ar-carousel]').forEach(function (carousel) {
      if (carousel.dataset.ctrArCarouselReady === '1') return;
      carousel.dataset.ctrArCarouselReady = '1';

      var track = carousel.querySelector('[data-ctr-ar-carousel-track]');
      var slides = carousel.querySelectorAll('[data-ctr-ar-carousel-slide]');
      var prev = carousel.querySelector('[data-ctr-ar-carousel-prev]');
      var next = carousel.querySelector('[data-ctr-ar-carousel-next]');
      var dotsWrap = carousel.querySelector('[data-ctr-ar-carousel-dots]');
      var thumbs = carousel.querySelectorAll('[data-ctr-ar-carousel-thumb]');
      if (!track || !slides.length) return;

      var index = 0;
      var dots = [];
      var navigating = false;
      var navTimer;
      var pointerId = null;
      var dragStartX = 0;
      var dragStartScroll = 0;
      var dragging = false;
      var didDrag = false;

      function maxScrollLeft() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function slideScrollLeft(slide) {
        return slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      }

      function ensureSlideStops() {
        if (window.getComputedStyle(track).display === 'grid') {
          var gridSpacer = track.querySelector('[data-ctr-ar-carousel-spacer]');
          if (gridSpacer) gridSpacer.style.display = 'none';
          return;
        }
        var last = slides[slides.length - 1];
        if (!last) return;
        var spacer = track.querySelector('[data-ctr-ar-carousel-spacer]');
        if (!spacer) {
          spacer = document.createElement('div');
          spacer.setAttribute('data-ctr-ar-carousel-spacer', '');
          spacer.setAttribute('aria-hidden', 'true');
          spacer.style.flex = '0 0 auto';
          spacer.style.height = '1px';
          spacer.style.pointerEvents = 'none';
          track.appendChild(spacer);
        }
        spacer.style.display = '';
        spacer.style.width = '0px';
        var pad = Math.max(0, track.clientWidth - last.getBoundingClientRect().width);
        spacer.style.width = pad + 'px';
      }

      function slideTarget(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        return Math.min(slideScrollLeft(slides[i]), maxScrollLeft());
      }

      function indexFromScroll() {
        var sl = track.scrollLeft;
        var closest = 0;
        var best = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var dist = Math.abs(slideTarget(i) - sl);
          if (dist < best) {
            best = dist;
            closest = i;
          }
        }
        return closest;
      }

      function goTo(i, behavior) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        index = i;
        navigating = true;
        updateControls();
        ensureSlideStops();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.scrollTo({ left: slideTarget(index), behavior: behavior || 'smooth' });
            clearTimeout(navTimer);
            navTimer = setTimeout(function () { navigating = false; }, 500);
          });
        });
      }

      function updateControls() {
        var atStart = index <= 0;
        var atEnd = index >= slides.length - 1;
        if (prev) {
          prev.classList.toggle('is-inactive', atStart);
          prev.disabled = atStart;
          prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        }
        if (next) {
          next.classList.toggle('is-inactive', atEnd);
          next.disabled = atEnd;
          next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
        dots.forEach(function (dot, di) {
          dot.classList.toggle('is-active', di === index);
        });
        thumbs.forEach(function (thumb, ti) {
          thumb.classList.toggle('is-active', ti === index);
        });
        slides.forEach(function (slide, si) {
          slide.classList.toggle('is-active', si === index);
        });
      }

      if (dotsWrap && slides.length > 1) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ctr-ar-carousel__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.addEventListener('click', function () { goTo(i); });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        });
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { goTo(i); });
      });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        if (navigating || dragging) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          if (navigating || dragging) return;
          index = indexFromScroll();
          updateControls();
        }, 80);
      });

      function endDrag(e) {
        if (pointerId !== e.pointerId) return;
        pointerId = null;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        if (!dragging) {
          navigating = false;
          return;
        }
        dragging = false;
        index = indexFromScroll();
        goTo(index);
      }

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.button != null && e.button !== 0) return;
        pointerId = e.pointerId;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        dragging = false;
        didDrag = false;
        navigating = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });

      track.addEventListener('pointermove', function (e) {
        if (pointerId !== e.pointerId) return;
        var dx = e.clientX - dragStartX;
        if (!dragging && Math.abs(dx) > 6) {
          dragging = true;
          didDrag = true;
          track.classList.add('is-dragging');
        }
        if (!dragging) return;
        e.preventDefault();
        track.scrollLeft = dragStartScroll - dx;
        index = indexFromScroll();
        updateControls();
      });

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('click', function (e) {
        if (!didDrag) return;
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }, true);

      ensureSlideStops();
      updateControls();
      window.addEventListener('resize', function () {
        ensureSlideStops();
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-ctr-ar-faq]').forEach(function (list) {
      if (list.dataset.ctrArFaqReady === '1') return;
      list.dataset.ctrArFaqReady = '1';
      var allowMultiple = list.getAttribute('data-ctr-ar-faq-multiple') === 'true';

      function closeItem(item) {
        var body = item.querySelector('[data-ctr-ar-faq-body]');
        if (body) {
          body.style.height = body.scrollHeight + 'px';
          body.offsetHeight;
          body.style.height = '0px';
        }
        item.classList.remove('is-active');
        var btn = item.querySelector('[data-ctr-ar-faq-trigger]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }

      function closeAll() {
        list.querySelectorAll('[data-ctr-ar-faq-item]').forEach(closeItem);
      }

      function openItem(item) {
        if (!allowMultiple) closeAll();
        item.classList.add('is-active');
        var trigger = item.querySelector('[data-ctr-ar-faq-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var body = item.querySelector('[data-ctr-ar-faq-body]');
        if (body) body.style.height = body.scrollHeight + 'px';
      }

      list.querySelectorAll('[data-ctr-ar-faq-item].is-active [data-ctr-ar-faq-body]').forEach(function (body) {
        body.style.height = body.scrollHeight + 'px';
      });

      list.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-ctr-ar-faq-trigger]');
        if (!trigger || !list.contains(trigger)) return;
        e.preventDefault();
        var item = trigger.closest('[data-ctr-ar-faq-item]');
        if (!item) return;
        if (item.classList.contains('is-active')) closeItem(item);
        else openItem(item);
      });

      list.ctrArFaq = { open: openItem, closeAll: closeAll };
    });
  }

  function initModals(root) {
    root.querySelectorAll('[data-ctr-ar-modal]').forEach(function (modal) {
      if (modal.dataset.ctrArModalReady === '1') return;
      modal.dataset.ctrArModalReady = '1';

      function closeModal() {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
        document.documentElement.classList.remove('ctr-ar-modal-open');
      }

      function openModal() {
        modal.querySelectorAll('img').forEach(function (img) {
          img.loading = 'eager';
        });
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
        document.documentElement.classList.add('ctr-ar-modal-open');
      }

      modal.querySelectorAll('[data-ctr-ar-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          closeModal();
        });
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      modal.addEventListener('cancel', function () {
        document.documentElement.classList.remove('ctr-ar-modal-open');
      });
      modal.ctrArModal = { open: openModal, close: closeModal };
    });
  }

  function bindModalTriggers(root) {
    root.querySelectorAll('[data-ctr-ar-modal-open]').forEach(function (trigger) {
      if (trigger.dataset.ctrArModalTriggerReady === '1') return;
      trigger.dataset.ctrArModalTriggerReady = '1';
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var id = trigger.getAttribute('data-ctr-ar-modal-open');
        if (!id) return;
        var modal = document.querySelector('[data-ctr-ar-modal="' + id + '"]');
        if (modal && modal.ctrArModal) modal.ctrArModal.open();
      });
    });
  }

  function money(cents, symbol) {
    var n = (Number(cents) || 0) / 100;
    return (symbol || '$') + n.toFixed(2);
  }

  function initBuybox(root) {
    root.querySelectorAll('[data-ctr-ar-buybox]').forEach(function (box) {
      if (box.dataset.ctrArBuyboxReady === '1') return;
      box.dataset.ctrArBuyboxReady = '1';

      var jsonEl = box.querySelector('[data-ctr-ar-product-json]');
      if (!jsonEl) return;
      var data;
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (err) {
        return;
      }

      var variants = data.variants || [];
      var groups = data.selling_plan_groups || [];
      var defaultVariants = variants;
      var defaultGroups = groups;
      var excludedPlanIds = String(data.excluded_selling_plan_ids || '')
        .split(/[\s,]+/)
        .filter(Boolean);
      var includedPlanIds = String(data.included_selling_plan_ids || '')
        .split(/[\s,]+/)
        .filter(Boolean);
      var symbol = data.currency_symbol || '$';
      var subscribe = true;
      var variantId = data.selected_variant_id || (variants[0] && variants[0].id);
      var sellingPlanId = null;
      var quantity = 1;

      var sizePlanIds = [];

      function parsePlanIds(value) {
        return String(value || '')
          .split(/[\s,]+/)
          .filter(Boolean);
      }

      function currentVariant() {
        return variants.find(function (v) { return String(v.id) === String(variantId); }) || variants[0];
      }

      function isExcludedPlan(plan) {
        return !!(plan && excludedPlanIds.indexOf(String(plan.id)) !== -1);
      }

      function plansForVariant(variant) {
        var ids = (variant && variant.selling_plan_allocations || []).map(function (a) { return String(a.selling_plan_id); });
        var allow = sizePlanIds;
        var plans = [];
        groups.forEach(function (g) {
          (g.selling_plans || []).forEach(function (p) {
            var id = String(p.id);
            if (ids.indexOf(id) === -1) return;
            if (allow.length) {
              if (allow.indexOf(id) !== -1) plans.push(p);
            } else if (includedPlanIds.length) {
              if (includedPlanIds.indexOf(id) !== -1) plans.push(p);
            } else if (!isExcludedPlan(p)) {
              plans.push(p);
            }
          });
        });
        if (includedPlanIds.length && !allow.length) {
          plans.sort(function (a, b) {
            return includedPlanIds.indexOf(String(a.id)) - includedPlanIds.indexOf(String(b.id));
          });
        }
        return plans;
      }

      function formatOff(cents) {
        var n = Math.max(0, Math.round(Number(cents) || 0));
        if (n % 100 === 0) return '$' + String(n / 100);
        return money(n, symbol);
      }

      function applyAdjustment(base, adj) {
        var value = Number(adj && adj.value) || 0;
        if (!adj) return base;
        if (adj.value_type === 'percentage') return Math.round(base * (100 - value) / 100);
        if (adj.value_type === 'fixed_amount') return Math.max(0, base - value);
        if (adj.value_type === 'price') return value;
        return base;
      }

      function planById(planId) {
        var found = null;
        groups.forEach(function (g) {
          (g.selling_plans || []).forEach(function (p) {
            if (String(p.id) === String(planId)) found = p;
          });
        });
        return found;
      }

      function recurringUnitPrice(variant, planId) {
        var base = Number(variant.price);
        var plan = planById(planId);
        var adjs = (plan && plan.price_adjustments) || [];
        var ongoing = null;
        adjs.forEach(function (adj) {
          if (adj.order_count == null || Number(adj.order_count) === 0) ongoing = adj;
        });
        if (!ongoing && adjs.length > 1) ongoing = adjs[adjs.length - 1];
        if (!ongoing) return base;
        if (adjs.length === 1 && Number(adjs[0].order_count) === 1) return base;
        return applyAdjustment(base, ongoing);
      }

      function updateSavings() {
        if (!data.dynamic_dollar_savings) return;
        var variant = currentVariant();
        if (!variant) return;
        var qty = quantity || 1;
        var shipping = Number(data.onetime_shipping_cents) || 0;
        var oneCents = Number(variant.price) * qty + shipping;
        var alloc = sellingPlanId ? allocation(variant, sellingPlanId) : null;
        var subCents = Number(alloc ? alloc.price : variant.price) * qty;
        var laterCents = recurringUnitPrice(variant, sellingPlanId) * qty;
        var firstOff = Math.max(0, oneCents - subCents);
        var laterOff = Math.max(0, oneCents - laterCents);
        var badge = box.querySelector('[data-ctr-ar-save-badge]');
        if (badge) badge.textContent = formatOff(firstOff) + ' OFF';
        box.querySelectorAll('[data-ctr-ar-savings="first"]').forEach(function (el) {
          el.textContent = formatOff(firstOff) + ' off this order';
        });
        box.querySelectorAll('[data-ctr-ar-savings="recurring"]').forEach(function (el) {
          el.textContent = formatOff(laterOff) + ' off every order after';
        });
      }

      function allocation(variant, planId) {
        if (!variant) return null;
        return (variant.selling_plan_allocations || []).find(function (a) {
          return String(a.selling_plan_id) === String(planId);
        });
      }

      function prettyPlanName(plan) {
        var raw = (plan && plan.name) || '';
        var n = raw.toLowerCase();
        if (/20\s*days/.test(n)) return 'Delivery every 20 days';
        if (/every\s*month|30\s*days|1\s*month/.test(n) && !/2\s*month|3\s*month|60|90/.test(n)) {
          return 'Delivery every month';
        }
        if (/(2|two)\s*months|60\s*days/.test(n)) return 'Delivery every 2 months';
        if (/(3|three)\s*months|90\s*days/.test(n)) return 'Delivery every 3 months';
        return raw;
      }

      function renderFrequency() {
        var select = box.querySelector('[data-ctr-ar-frequency]');
        if (!select) return;
        var variant = currentVariant();
        var plans = plansForVariant(variant);
        select.innerHTML = '';
        plans.forEach(function (p, i) {
          var opt = document.createElement('option');
          opt.value = p.id;
          opt.textContent = prettyPlanName(p) || (p.options && p.options[0] && p.options[0].value) || ('Plan ' + (i + 1));
          select.appendChild(opt);
        });
        if (plans.length) {
          if (!sellingPlanId || !plans.some(function (p) { return String(p.id) === String(sellingPlanId); })) {
            sellingPlanId = plans[0].id;
          }
          select.value = sellingPlanId;
        } else {
          sellingPlanId = null;
        }
      }

      function updatePrices() {
        var variant = currentVariant();
        if (!variant) return;
        var qty = quantity || 1;
        var shipping = Number(data.onetime_shipping_cents) || 0;
        // Flat OTP shipping add-on from the customizer — always once, never per dog.
        var oneCents = Number(variant.price) * qty + shipping;
        var oneEl = box.querySelector('[data-ctr-ar-price-onetime]');
        var subEl = box.querySelector('[data-ctr-ar-price-subscribe]');
        var compareEl = box.querySelector('[data-ctr-ar-price-compare]');
        if (oneEl) oneEl.textContent = money(oneCents, symbol);
        var alloc = sellingPlanId ? allocation(variant, sellingPlanId) : null;
        var subCents = Number(alloc ? alloc.price : variant.price) * qty;
        if (subEl) subEl.textContent = money(subCents, symbol);
        if (compareEl) {
          compareEl.textContent = money(oneCents, symbol);
          compareEl.hidden = !(subCents < oneCents);
        }
        updateSavings();
      }

      function setSubscribe(on) {
        subscribe = !!on;
        box.querySelectorAll('[data-ctr-ar-purchase]').forEach(function (el) {
          var isSub = el.getAttribute('data-ctr-ar-purchase') === 'subscribe';
          el.classList.toggle('is-active', isSub === subscribe);
          var radio = el.querySelector('input[type="radio"]');
          if (radio) radio.checked = isSub === subscribe;
        });
        updatePrices();
      }

      box.querySelectorAll('[data-ctr-ar-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          variantId = btn.getAttribute('data-ctr-ar-size');
          box.querySelectorAll('[data-ctr-ar-size]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          renderFrequency();
          updatePrices();
        });
      });

      box.querySelectorAll('[data-ctr-ar-purchase]').forEach(function (el) {
        el.addEventListener('click', function () {
          setSubscribe(el.getAttribute('data-ctr-ar-purchase') === 'subscribe');
        });
      });

      var freq = box.querySelector('[data-ctr-ar-frequency]');
      if (freq) {
        freq.addEventListener('change', function () {
          sellingPlanId = freq.value;
          updatePrices();
        });
      }

      function addToCart(opts) {
        var variant = currentVariant();
        if (!variant) return;
        var atcBtn = box.querySelector('[data-ctr-ar-atc]');
        if (atcBtn) atcBtn.classList.add('is-loading');
        var payload = {
          id: variant.id,
          quantity: quantity,
          sections: ['cart-drawer', 'cart-icon-bubble']
        };
        if (opts.subscribe && sellingPlanId) payload.selling_plan = sellingPlanId;
        if (data.dynamic_dollar_savings) {
          payload.properties = {
            _ctr_price_test: 'joint',
            _ctr_otp_shipping_cents: String(Number(data.onetime_shipping_cents) || 0)
          };
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json(); })
          .then(function (json) {
            if (json.sections && json.sections['cart-drawer']) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(json.sections['cart-drawer'], 'text/html');
              var next = doc.querySelector('cart-drawer');
              var cur = document.querySelector('cart-drawer');
              if (cur && next) cur.replaceWith(next);
              var bubbleDoc = parser.parseFromString(json.sections['cart-icon-bubble'] || '', 'text/html');
              var newBubble = bubbleDoc.querySelector('.cart-count-bubble');
              var curBubble = document.querySelector('.cart-count-bubble');
              var cartIcon = document.querySelector('#cart-icon-bubble');
              if (curBubble && newBubble) {
                curBubble.replaceWith(newBubble);
              } else if (!curBubble && newBubble && cartIcon) {
                cartIcon.appendChild(newBubble);
              }
              var drawer = document.querySelector('cart-drawer');
              if (drawer) drawer.classList.add('active');
            }
          })
          .catch(function (err) { console.error('ctr-ar ATC', err); })
          .finally(function () {
            if (atcBtn) atcBtn.classList.remove('is-loading');
          });
      }

      function unitVariant(list) {
        return (list || []).find(function (v) {
          return /1-pack/i.test(v.title || '');
        }) || (list && list[0]);
      }

      function applyCatalog(source, planIdsStr) {
        var altVariants = data.alt_variants || [];
        var altGroups = data.alt_selling_plan_groups || [];
        if (source === 'alt' && altVariants.length) {
          variants = altVariants;
          groups = altGroups;
        } else {
          variants = defaultVariants;
          groups = defaultGroups;
        }
        sizePlanIds = parsePlanIds(planIdsStr);
        var unit = unitVariant(variants);
        if (unit) variantId = unit.id;
        sellingPlanId = null;
        renderFrequency();
        updatePrices();
      }

      box.querySelectorAll('[data-ctr-ar-dog-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          box.querySelectorAll('[data-ctr-ar-dog-size]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          applyCatalog(
            btn.getAttribute('data-ctr-ar-product-source') || 'default',
            btn.getAttribute('data-ctr-ar-selling-plan-ids')
          );
        });
      });

      var qtyWrap = box.querySelector('[data-ctr-ar-qty]');
      if (qtyWrap) {
        var qtyValue = qtyWrap.querySelector('[data-ctr-ar-qty-value]');
        var qtyMinus = qtyWrap.querySelector('[data-ctr-ar-qty-minus]');
        var qtyPlus = qtyWrap.querySelector('[data-ctr-ar-qty-plus]');
        function setQty(next) {
          quantity = Math.max(1, Math.min(12, next));
          if (qtyValue) qtyValue.textContent = String(quantity);
          if (qtyMinus) qtyMinus.disabled = quantity <= 1;
          updatePrices();
        }
        if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(quantity - 1); });
        if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(quantity + 1); });
        setQty(1);
      }

      var supplyBtns = box.querySelectorAll('[data-ctr-ar-supply]');
      var supplyMode = box.getAttribute('data-ctr-ar-supply-mode') === 'true' || supplyBtns.length > 0;
      if (supplyBtns.length) {
        function setSupply(btn) {
          if (!btn) return;
          supplyBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          quantity = parseInt(btn.getAttribute('data-ctr-ar-supply'), 10) || 1;
          updatePrices();
          var variant = currentVariant();
          if (!variant) return;
          supplyBtns.forEach(function (card) {
            var pack = parseInt(card.getAttribute('data-ctr-ar-supply'), 10) || 1;
            var priceEl = card.querySelector('[data-ctr-ar-supply-price]');
            if (priceEl) priceEl.textContent = money(Number(variant.price) * pack, symbol);
          });
        }
        supplyBtns.forEach(function (btn) {
          btn.addEventListener('click', function () { setSupply(btn); });
        });
        setSupply(box.querySelector('[data-ctr-ar-supply].is-active') || supplyBtns[0]);
      }

      var atc = box.querySelector('[data-ctr-ar-atc]');
      if (atc) {
        atc.addEventListener('click', function () {
          addToCart({ subscribe: subscribe });
        });
      }

      var activeDogSize = box.querySelector('[data-ctr-ar-dog-size].is-active');
      if (activeDogSize) {
        applyCatalog(
          activeDogSize.getAttribute('data-ctr-ar-product-source') || 'default',
          activeDogSize.getAttribute('data-ctr-ar-selling-plan-ids')
        );
      } else {
        renderFrequency();
      }
      setSubscribe(!supplyMode);
    });
  }

  function stripEditorAttrs(node) {
    node.querySelectorAll('[data-shopify-editor-block]').forEach(function (child) {
      child.removeAttribute('data-shopify-editor-block');
    });
    node.removeAttribute('data-shopify-editor-block');
  }

  function resetClones(wrapper) {
    if (!wrapper) return;
    wrapper.querySelectorAll('[data-ctr-ar-clone]').forEach(function (clone) {
      clone.remove();
    });
  }

  function originalSlides(wrapper) {
    return [].slice.call(wrapper.querySelectorAll(':scope > .swiper-slide:not([data-ctr-ar-clone])'));
  }

  function markSlideIndexes(wrapper) {
    var originals = originalSlides(wrapper);
    originals.forEach(function (slide, i) {
      slide.setAttribute('data-ctr-ar-slide-index', String(i));
    });
    return originals;
  }

  function ensureLoopSlides(el, slideWidth, gap) {
    var wrapper = el && el.querySelector('.swiper-wrapper');
    if (!wrapper) return 0;

    resetClones(wrapper);
    var originals = markSlideIndexes(wrapper);
    var unique = originals.length;
    if (unique < 2) return unique;

    var width = (originals[0] && originals[0].getBoundingClientRect().width) || slideWidth;
    var containerWidth = el.offsetWidth || window.innerWidth;
    var visible = Math.max(1, containerWidth / (width + gap));
    var minSlides = Math.max(unique * 4, Math.ceil(visible * 2) + unique);

    var i = 0;
    while (wrapper.querySelectorAll(':scope > .swiper-slide').length < minSlides) {
      var clone = originals[i % unique].cloneNode(true);
      clone.setAttribute('data-ctr-ar-clone', '1');
      clone.setAttribute('aria-hidden', 'true');
      stripEditorAttrs(clone);
      wrapper.appendChild(clone);
      i += 1;
    }

    return unique;
  }

  function slideIndex(slide) {
    if (!slide) return 0;
    var attr = slide.getAttribute('data-ctr-ar-slide-index');
    if (attr != null && attr !== '') return parseInt(attr, 10) || 0;
    return 0;
  }

  function loopTarget(swiper, unique, index) {
    var current = swiper.realIndex;
    var base = current - (current % unique);
    return base + index;
  }

  function syncThumbState(thumbsEl, index) {
    if (!thumbsEl) return;
    thumbsEl.querySelectorAll('.ctr-ar-hero__thumb-slide').forEach(function (slide) {
      var active = slideIndex(slide) === index;
      slide.classList.toggle('is-active', active);
      var btn = slide.querySelector('.ctr-ar-hero__thumb');
      if (btn) btn.classList.toggle('is-active', active);
    });
  }

  function bindGalleryBreakpoint(gallery) {
    if (gallery.dataset.ctrArGalleryMq === '1') return;
    gallery.dataset.ctrArGalleryMq = '1';
    var mq = window.matchMedia('(max-width: 989px)');
    var onChange = function () {
      initGalleries(gallery.parentNode || document);
    };
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange);
    else if (typeof mq.addListener === 'function') mq.addListener(onChange);
  }

  function initGalleries(root) {
    if (typeof Swiper === 'undefined') return;
    var mobile = window.matchMedia('(max-width: 989px)').matches;

    root.querySelectorAll('[data-ctr-ar-gallery]').forEach(function (gallery) {
      var mainEl = gallery.querySelector('[data-ctr-ar-gallery-main]');
      var thumbsEl = gallery.querySelector('[data-ctr-ar-gallery-thumbs]');
      if (!mainEl) return;

      bindGalleryBreakpoint(gallery);

      if (mainEl.swiper) mainEl.swiper.destroy(true, true);
      if (thumbsEl && thumbsEl.swiper) thumbsEl.swiper.destroy(true, true);

      var unique;
      if (mobile) {
        unique = ensureLoopSlides(mainEl, 350, 8);
        if (thumbsEl) ensureLoopSlides(thumbsEl, 100, 8);
      } else {
        resetClones(mainEl.querySelector('.swiper-wrapper'));
        unique = markSlideIndexes(mainEl.querySelector('.swiper-wrapper')).length;
        if (thumbsEl) {
          resetClones(thumbsEl.querySelector('.swiper-wrapper'));
          markSlideIndexes(thumbsEl.querySelector('.swiper-wrapper'));
        }
      }

      if (!unique) return;

      var canLoop = unique > 1;
      var thumbsLoop = canLoop && mobile;
      var prev = gallery.querySelector('[data-ctr-ar-gallery-prev]');
      var next = gallery.querySelector('[data-ctr-ar-gallery-next]');
      var syncing = false;

      var thumbs = null;
      if (thumbsEl) {
        thumbs = new Swiper(thumbsEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          speed: 450,
          loop: thumbsLoop,
          centeredSlides: thumbsLoop,
          slideToClickedSlide: true,
          watchSlidesProgress: true,
          watchOverflow: false,
          observer: false,
          grabCursor: true
        });
      }

      var main = new Swiper(mainEl, {
        slidesPerView: mobile ? 'auto' : 1,
        spaceBetween: mobile ? 8 : 0,
        slidesOffsetBefore: mobile ? 20 : 0,
        slidesOffsetAfter: mobile ? 20 : 0,
        speed: 450,
        loop: canLoop,
        grabCursor: true,
        watchOverflow: false,
        slideToClickedSlide: mobile,
        observer: false,
        navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined
      });

      function goTo(index) {
        if (index == null || isNaN(index) || unique < 1) return;
        index = ((index % unique) + unique) % unique;
        syncing = true;
        if (main && canLoop) main.slideToLoop(loopTarget(main, unique, index));
        else if (main) main.slideTo(index);
        if (thumbs && thumbsLoop) thumbs.slideToLoop(loopTarget(thumbs, unique, index));
        else if (thumbs) thumbs.slideTo(index);
        syncThumbState(thumbsEl, index);
        syncing = false;
      }

      function syncGalleryVideos() {
        if (!mainEl) return;
        mainEl.querySelectorAll('video').forEach(function (video) {
          var slide = video.closest('.swiper-slide');
          var active = slide && slide.classList.contains('swiper-slide-active');
          if (!active) {
            video.pause();
            return;
          }
          video.muted = true;
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        });
      }

      if (main) {
        main.on('slideChange', function () {
          if (syncing || unique < 1) return;
          var index = ((main.realIndex % unique) + unique) % unique;
          syncing = true;
          if (thumbs && thumbsLoop) thumbs.slideToLoop(loopTarget(thumbs, unique, index));
          else if (thumbs) thumbs.slideTo(index);
          syncThumbState(thumbsEl, index);
          syncing = false;
          syncGalleryVideos();
        });
        main.on('slideChangeTransitionEnd', syncGalleryVideos);
        syncGalleryVideos();
      }

      if (thumbs) {
        thumbs.on('click', function () {
          goTo(slideIndex(thumbs.clickedSlide));
        });
      }

      syncThumbState(thumbsEl, 0);
    });
  }

  function initSwipers(root) {
    if (typeof Swiper === 'undefined') return;
    root.querySelectorAll('[data-ctr-ar-swiper]').forEach(function (wrap) {
      var type = wrap.getAttribute('data-ctr-ar-swiper');
      var el = wrap.classList.contains('swiper') ? wrap : wrap.querySelector('.swiper');
      if (!el || el.swiper) return;
      var pagination = wrap.querySelector('.swiper-pagination');
      var options = {
        grabCursor: true,
        watchOverflow: false,
        observer: true,
        observeParents: true
      };
      if (type === 'reviews') {
        options.slidesPerView = 'auto';
        options.spaceBetween = 16;
      }
      if (type === 'timeline') {
        var slideCount = el.querySelectorAll('.swiper-slide').length || 4;
        options.slidesPerView = 1.2;
        options.spaceBetween = 16;
        options.breakpoints = {
          990: {
            slidesPerView: Math.min(4, slideCount),
            spaceBetween: 20,
            allowTouchMove: false,
            pagination: { enabled: false }
          }
        };
      }
      if (pagination) {
        options.pagination = { el: pagination, clickable: true };
      }
      el.swiper = new Swiper(el, options);
    });
  }

  function syncVideoToggle(btn, video) {
    var paused = video.paused;
    btn.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
  }

  function initVideoToggles(root) {
    root.querySelectorAll('[data-ctr-hp-video-toggle]').forEach(function (btn) {
      if (btn.dataset.ctrHpVideoReady === '1') return;
      btn.dataset.ctrHpVideoReady = '1';

      var host =
        btn.closest('.ctr-ar-reviews__media') ||
        btn.closest('.ctr-hp-compare__media') ||
        btn.parentElement;
      var video = host && host.querySelector('video');
      if (!video) {
        btn.hidden = true;
        return;
      }

      syncVideoToggle(btn, video);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }
        syncVideoToggle(btn, video);
      });

      video.addEventListener('play', function () {
        syncVideoToggle(btn, video);
      });
      video.addEventListener('pause', function () {
        syncVideoToggle(btn, video);
      });
    });
  }

  function initSymptoms(root) {
    root.querySelectorAll('[data-ctr-ar-symptoms]').forEach(function (wrap) {
      if (wrap.dataset.ctrArSymptomsReady === '1') return;
      wrap.dataset.ctrArSymptomsReady = '1';

      var cards = wrap.querySelectorAll('.ctr-ar-symptoms__card');
      var prev = wrap.querySelector('[data-ctr-ar-symptoms-prev]');
      var next = wrap.querySelector('[data-ctr-ar-symptoms-next]');
      var viewport = wrap.querySelector('.ctr-ar-symptoms__viewport');
      if (!cards.length) return;

      var index = 0;

      function scrollActiveIntoView() {
        var active = cards[index];
        if (!active || !viewport) return;
        var vRect = viewport.getBoundingClientRect();
        var aRect = active.getBoundingClientRect();
        var nextLeft = viewport.scrollLeft;
        if (aRect.left < vRect.left) {
          nextLeft += aRect.left - vRect.left;
        } else if (aRect.right > vRect.right) {
          nextLeft += aRect.right - vRect.right;
        }
        nextLeft = Math.max(0, nextLeft);
        if (Math.abs(nextLeft - viewport.scrollLeft) > 1) {
          viewport.scrollTo({ left: nextLeft, behavior: 'smooth' });
        }
      }

      function setActive(i) {
        index = Math.max(0, Math.min(cards.length - 1, i));
        cards.forEach(function (card, n) {
          card.classList.toggle('is-active', n === index);
        });
        if (prev) {
          prev.disabled = index === 0;
          prev.classList.toggle('is-inactive', index === 0);
          prev.setAttribute('aria-disabled', index === 0 ? 'true' : 'false');
        }
        if (next) {
          var atEnd = index === cards.length - 1;
          next.disabled = atEnd;
          next.classList.toggle('is-inactive', atEnd);
          next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
        requestAnimationFrame(scrollActiveIntoView);
        var active = cards[index];
        if (active) {
          var onEnd = function (e) {
            if (e.target !== active || e.propertyName !== 'width') return;
            active.removeEventListener('transitionend', onEnd);
            scrollActiveIntoView();
          };
          active.addEventListener('transitionend', onEnd);
        }
      }

      if (prev) {
        prev.addEventListener('click', function () { setActive(index - 1); });
      }
      if (next) {
        next.addEventListener('click', function () { setActive(index + 1); });
      }
      cards.forEach(function (card, n) {
        card.addEventListener('click', function () { setActive(n); });
      });

      wrap.ctrArSymptoms = { setActive: setActive };
      setActive(0);
    });
  }

  function initAll(root) {
    initGalleries(root);
    initSwipers(root);
    initSymptoms(root);
    initCarousels(root);
    initFaq(root);
    initModals(root);
    bindModalTriggers(root);
    initBuybox(root);
    initVideoToggles(root);
    initImpactInfo(root);
  }

  function initImpactInfo(root) {
    root.querySelectorAll('[data-ctr-ar-info]').forEach(function (wrap) {
      if (wrap.dataset.ctrArInfoReady === '1') return;
      wrap.dataset.ctrArInfoReady = '1';
      var trigger = wrap.querySelector('[data-ctr-ar-info-trigger]');
      var tip = wrap.querySelector('[data-ctr-ar-info-tip]');
      var close = wrap.querySelector('[data-ctr-ar-info-close]');
      if (!trigger || !tip) return;

      function setOpen(open) {
        wrap.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) tip.removeAttribute('hidden');
        else tip.setAttribute('hidden', '');
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!wrap.classList.contains('is-open'));
      });
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          wrap.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          tip.setAttribute('hidden', '');
        });
      }
      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          tip.setAttribute('hidden', '');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          wrap.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          tip.setAttribute('hidden', '');
        }
      });
    });
  }

  function scrollBlockIntoView(el) {
    if (!el || typeof el.scrollIntoView !== 'function') return;
    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    } catch (err) {
      el.scrollIntoView(true);
    }
  }

  ready(function () {
    initAll(document);

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) initAll(e.target);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var block = e.target;
      if (!block) return;
      var swiperSlide = block.closest('.swiper-slide');
      if (swiperSlide) {
        var swiperEl = swiperSlide.closest('.swiper');
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.slideTo(swiperEl.swiper.slides.indexOf(swiperSlide));
        }
      }
      var symptomCard = block.closest('.ctr-ar-symptoms__card');
      if (symptomCard) {
        var symptoms = symptomCard.closest('[data-ctr-ar-symptoms]');
        if (symptoms && symptoms.ctrArSymptoms) {
          var symptomCards = symptoms.querySelectorAll('.ctr-ar-symptoms__card');
          symptoms.ctrArSymptoms.setActive(Array.prototype.indexOf.call(symptomCards, symptomCard));
        }
      }
      var slide = block.closest('[data-ctr-ar-carousel-slide]') || (block.matches('[data-ctr-ar-carousel-slide]') ? block : null);
      if (slide) {
        var carousel = slide.closest('[data-ctr-ar-carousel]');
        var track = carousel && carousel.querySelector('[data-ctr-ar-carousel-track]');
        if (track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      var faqItem = block.closest('[data-ctr-ar-faq-item]') || (block.matches('[data-ctr-ar-faq-item]') ? block : null);
      if (faqItem) {
        var list = faqItem.closest('[data-ctr-ar-faq]');
        if (list && list.ctrArFaq) list.ctrArFaq.open(faqItem);
      }
      scrollBlockIntoView(block);
    });
  });
})();
